var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVrArIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#A0D911"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_1682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6859 11.4854H5.31445V16.6282C5.31445 16.901 5.42282 17.1626 5.61571 17.3555C5.80861 17.5484 6.07023 17.6568 6.34302 17.6568H9.42874C9.58324 17.6561 9.73559 17.6206 9.87448 17.5529C10.0134 17.4852 10.1352 17.3871 10.231 17.2659L11.5785 15.5894C11.6266 15.5293 11.6877 15.4808 11.7571 15.4475C11.8266 15.4142 11.9026 15.3969 11.9796 15.3969C12.0566 15.3969 12.1326 15.4142 12.2021 15.4475C12.2715 15.4808 12.3325 15.5293 12.3807 15.5894L13.7487 17.2659C13.8445 17.3871 13.9664 17.4852 14.1053 17.5529C14.2442 17.6206 14.3965 17.6561 14.551 17.6568H17.6367C17.9095 17.6568 18.1712 17.5484 18.364 17.3555C18.5569 17.1626 18.6653 16.901 18.6653 16.6282L18.6859 11.4854Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6859 11.4851L15.8985 6.85654C15.8074 6.703 15.678 6.57579 15.5229 6.48742C15.3678 6.39905 15.1924 6.35257 15.0139 6.35254H8.98645C8.80795 6.35257 8.63253 6.39905 8.47744 6.48742C8.32234 6.57579 8.19292 6.703 8.10188 6.85654L5.31445 11.4851",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_1682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrArIcon);
export default __webpack_public_path__ + "static/media/vr_ar_icon.3a52b723af21d2a6697c686fda992609.svg";
export { ForwardRef as ReactComponent };